import { defineComponent as _defineComponent } from 'vue'
import {useTransactionContextStore} from "@/store/transactionContext.store";
import {computed, onBeforeMount, ref, watch} from "vue";
import {useUserServiceStore} from "@/store/userService.store";
import {useToast} from "vue-toastification";
import {usePublicSalesStore} from "@/store/publicSales.store";
import {ethers} from "ethers";
import {useRouter} from "vue-router";
import Icon from "@/components/features/IconComponent.vue";
import QrcodeVue from 'qrcode.vue';
import {Field, Form} from "vee-validate";
import {object} from "yup";
import * as Yup from "yup";
import Dialog from "primevue/dialog";
import IconComponent from "@/components/features/IconComponent.vue";
import {useUserStore} from "@/store/user.store";
import WarningModal from "@/components/buyTokens/modals/WarningModal.vue";
import i18n from "@/plugins/i18n";
import {useConfigurationStore} from "@/store/configuration.store";
import Dropdown from "primevue/dropdown";
import {CHAIN_NAME, TOKEN_NAME} from "@/models/saleServiceCommons";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentConfirmationView',
  setup(__props, { expose: __expose }) {
  __expose();


onBeforeMount(async () => {
  useUserStore().connectMetamask();
  await publicSaleStore.fetchRoundInfo(useConfigurationStore().config.currentPublicSaleRoundId,false);
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const {chainId} = await provider.getNetwork();
  changeNetwork(chainId);
});
const sourceAddress = ref(useUserServiceStore().ethereumAddress);
const currentMetamaskAddress = computed(() => {
  return useUserStore().metamaskConnectionInfo.address;
});

const transactionContextStore = useTransactionContextStore();
const router = useRouter();
const publicSaleStore = usePublicSalesStore();
const txHash = ref<string>();
const paymentModalVisible = ref(false);
const showManualPayment = ref<boolean>(false);

const warningModalVisibility = ref(false);


const blockchainAndTokenSelected = () => {
  return selectedToken.value && selectedBlockchain.value;
};
const addressNotMatch = computed(() => {
  return useUserStore().metamaskConnectionInfo.address.toLowerCase() != useUserServiceStore().ethereumAddress?.toLowerCase();
});
const schema = object().shape({
  txHash:  Yup.string()
    .required( "This field is required"),
  selectedBlockchain:  Yup.object().required( "This field is required"),
  selectedToken:  Yup.object()
    .required( "This field is required"),

});

// const modalSchema = object().shape({
//   selectedBlockchain:  Yup.string()
//     .required( "This field is required"),
//
// });
const blockchainNetworkList = computed(() => {
  return publicSaleStore.blockchainInfo;
});

const selectedToken = ref();
// const selectedBlockchainNetworkId = ref();
const selectedBlockchainTokens = computed(() => {
  return blockchainNetworkList.value.find(blockchain => {
    return blockchain.chainId == selectedBlockchain.value?.chainId;
  })?.tokenExchanges;
});
const selectedBlockchain = ref();

// const selectedToken = computed(() => {
//   if(selectedBlockchainTokens.value) {
//     return selectedBlockchainTokens.value.find(token => {
//       return token.coinIdentifier == selectedTokenIdentifier.value;
//     });
//   }
//   return undefined;
// });
const onNetworkChange = () => {

  useUserServiceStore().switchBlockchain( selectedBlockchain.value.chainId);
  changeNetwork(selectedBlockchain.value.chainId);
};

const toast = useToast();
function copyRecipientAddress(){
  if(selectedToken.value?.recipientAddress) {
    navigator.clipboard.writeText(selectedToken.value.recipientAddress);
    useToast().success(i18n.global.t('COPY.ADDRESS'));
  }
}

const onFail = () => {
  // toast.error('An error occured');
};

const onStartMetamaskTransaction = () => {
  useUserStore().connectMetamask().then(address => {
    if(address != useUserServiceStore().ethereumAddress) {
      toast.error('Wrong address. Change to '+sourceAddress.value);
    } else {
      if(selectedBlockchain.value && selectedToken.value){
        usePublicSalesStore().payByMetamask({
          amount: transactionContextStore.amountToPay.amount.toString(),
          blockchainID: selectedBlockchain.value.id,
          exchangeID: selectedToken.value.id,
          orderId: transactionContextStore.orderId,
          blockchainAddress: selectedToken.value.coinIdentifier,
          coinDecimals: selectedToken.value.decimals,
          c4eAddress: selectedToken.value.recipientAddress
        }, onSuccessStartMetamaskTransaction, onFail);
      }
    }
  });
};
const onSuccessStartMetamaskTransaction = () => {
  usePublicSalesStore().fetchTokenReservations();
  paymentModalVisible.value = false;
  toast.success('Transaction complete');
  router.push({name: 'publicSaleInfo'});
};
const changeNetwork = (networkId: number) => {

  let isNetworkCorrect = false;
  blockchainNetworkList.value.forEach((network) => {
    if(network.chainId == networkId) {
      isNetworkCorrect = true;
      selectedBlockchain.value = network;
      if (selectedBlockchainTokens.value)
        selectedToken.value = selectedBlockchainTokens.value[0];
    }
  });
  if(!isNetworkCorrect) {
    selectedBlockchain.value = undefined;
    selectedToken.value = undefined;
  }
};
// window.addEventListener("load", function() {
//   console.log('co jest asdasdasd')
//   if (window.ethereum) {
//
//     window.ethereum.enable();
//
//     window.ethereum.on('networkChanged', function(networkId: number){
//       console.log('asdasdasd')
//       console.log(networkId)
//
//     });
//   }
// });

watch(() => useUserStore().metamaskConnectionInfo.networkId, () => {
  changeNetwork(useUserStore().metamaskConnectionInfo.networkId);
});

const onConfirmPayment = () => {
  if(selectedBlockchain.value && txHash.value && selectedToken.value) {
    usePublicSalesStore().provideTxPaymentProof({
      blockchainID: selectedBlockchain.value.id,
      orderID: transactionContextStore.orderId,
      exchangeID: selectedToken.value.id,
      txHashes: [txHash.value]
    }, onSuccessConfirmPayment, onFail);
  }
};
const onSuccessConfirmPayment = () => {
  usePublicSalesStore().fetchTokenReservations();
  toast.success('Payment confimed');
  router.push({name: 'publicSaleInfo'});
};


const __returned__ = { sourceAddress, currentMetamaskAddress, transactionContextStore, router, publicSaleStore, txHash, paymentModalVisible, showManualPayment, warningModalVisibility, blockchainAndTokenSelected, addressNotMatch, schema, blockchainNetworkList, selectedToken, selectedBlockchainTokens, selectedBlockchain, onNetworkChange, toast, copyRecipientAddress, onFail, onStartMetamaskTransaction, onSuccessStartMetamaskTransaction, changeNetwork, onConfirmPayment, onSuccessConfirmPayment, Icon, QrcodeVue, get Field() { return Field }, get Form() { return Form }, get Dialog() { return Dialog }, IconComponent, WarningModal, get Dropdown() { return Dropdown }, get CHAIN_NAME() { return CHAIN_NAME }, get TOKEN_NAME() { return TOKEN_NAME } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})